import { Box } from '@mui/material';
import { TextSpan } from '../../../Atoms/Text';
import { formatFileSize } from '../../../../utils/formatFileSize';
import { CARD_QUIET_ACTION } from './supplierCardStyles';

export interface AttachedInvoiceProps {
  file: File;
  disabled: boolean;
  onRemove: () => void;
}

export const AttachedInvoice = ({ file, disabled, onRemove }: AttachedInvoiceProps) => (
  <Box className="flex items-center gap-2 rounded-md bg-grey-1 px-3 py-2">
    <TextSpan size="xs">{file.name}</TextSpan>
    <TextSpan
      size="xs"
      color="grey6">
      {formatFileSize(file.size)}
    </TextSpan>
    <button
      type="button"
      className={`ml-auto ${CARD_QUIET_ACTION}`}
      disabled={disabled}
      onClick={onRemove}>
      Remove
    </button>
  </Box>
);
